module.exports = {
	"ha": "nha",
	"id": 5.5,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category and MSM Status, Year Ending 2022 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "50%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "50%",
				"height": "50%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -100,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0d4440"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#09472e"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0d4440"
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 37.5,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0d4440"
					},
					{
						"y": 75,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#09472e"
					},
					{
						"y": 25,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.55172413793103,
						"dataLabels": {
							"enabled": false,
							"format": "28"
						},
						"color": "#043f61"
					},
					{
						"y": 89.65517241379311,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.65517241379311,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.20689655172413,
						"dataLabels": {
							"enabled": false,
							"format": "25"
						},
						"color": "#09472e"
					},
					{
						"y": 58.620689655172406,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#043f61"
					},
					{
						"y": 42.857142857142854,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0c4250"
					},
					{
						"y": 28.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0d4440"
					},
					{
						"y": 14.285714285714285,
						"dataLabels": {
							"enabled": false,
							"format": "1"
						},
						"color": "#09472e"
					},
					{
						"y": 0,
						"dataLabels": {
							"enabled": false,
							"format": "0"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#043f61"
					},
					{
						"y": 89.47368421052632,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.94736842105263,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.42105263157895,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#09472e"
					},
					{
						"y": 26.31578947368421,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#0d4440"
					},
					{
						"y": 88.23529411764706,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 35.294117647058826,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "89"
						},
						"color": "#043f61"
					},
					{
						"y": 95.50561797752809,
						"dataLabels": {
							"enabled": false,
							"format": "85"
						},
						"color": "#0c4250"
					},
					{
						"y": 93.25842696629213,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.26966292134831,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#09472e"
					},
					{
						"y": 49.43820224719101,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#043f61"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0c4250"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0d4440"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "4"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#043f61"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.42857142857143,
						"dataLabels": {
							"enabled": false,
							"format": "5"
						},
						"color": "#09472e"
					},
					{
						"y": 28.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "2"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.44444444444444,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#043f61"
					},
					{
						"y": 72.22222222222221,
						"dataLabels": {
							"enabled": false,
							"format": "13"
						},
						"color": "#0c4250"
					},
					{
						"y": 61.111111111111114,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 38.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "7"
						},
						"color": "#09472e"
					},
					{
						"y": 16.666666666666664,
						"dataLabels": {
							"enabled": false,
							"format": "3"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 91.11111111111111,
						"dataLabels": {
							"enabled": false,
							"format": "41"
						},
						"color": "#043f61"
					},
					{
						"y": 80,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.77777777777779,
						"dataLabels": {
							"enabled": false,
							"format": "35"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#09472e"
					},
					{
						"y": 40,
						"dataLabels": {
							"enabled": false,
							"format": "18"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -66.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.4482758620689613,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -57.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -33.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -50,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -100,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.526315789473683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -61.53846153846154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.49438202247191,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.352941176470591,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.638554216867467,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -41.333333333333336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.666666666666664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -60,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.555555555555558,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.529411764705888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -36.36363636363637,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -57.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -8.888888888888891,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.195121951219512,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.777777777777779,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -40,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=2"
			},
			{
				"x": 9,
				"text": "30-39<br>n=8"
			},
			{
				"x": 15,
				"text": "40-49<br>n=8"
			},
			{
				"x": 21,
				"text": ">=50<br>n=29"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=7"
			},
			{
				"x": 34,
				"text": "30-39<br>n=19"
			},
			{
				"x": 40,
				"text": "40-49<br>n=34"
			},
			{
				"x": 46,
				"text": ">=50<br>n=89"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=10"
			},
			{
				"x": 59,
				"text": "30-39<br>n=7"
			},
			{
				"x": 65,
				"text": "40-49<br>n=18"
			},
			{
				"x": 71,
				"text": ">=50<br>n=45"
			}
		],
		"dataTable": {
			"MSM:<30": [
				2,
				2,
				2,
				2,
				2,
				2
			],
			"MSM:30-39": [
				8,
				8,
				8,
				8,
				5,
				3
			],
			"MSM:40-49": [
				8,
				8,
				8,
				8,
				6,
				2
			],
			"MSM:>=50": [
				29,
				28,
				26,
				26,
				25,
				17
			],
			"Non-MSM:<30": [
				7,
				7,
				3,
				2,
				1,
				0
			],
			"Non-MSM:30-39": [
				19,
				19,
				17,
				15,
				13,
				5
			],
			"Non-MSM:40-49": [
				34,
				34,
				34,
				34,
				30,
				12
			],
			"Non-MSM:>=50": [
				89,
				89,
				85,
				83,
				75,
				44
			],
			"Unknown:<30": [
				10,
				4,
				4,
				4,
				4,
				4
			],
			"Unknown:30-39": [
				7,
				7,
				6,
				6,
				5,
				2
			],
			"Unknown:40-49": [
				18,
				17,
				13,
				11,
				7,
				3
			],
			"Unknown:>=50": [
				45,
				41,
				36,
				35,
				30,
				18
			]
		}
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_5.json
// module id = 272
// module chunks = 0